import { helpers, selectors } from 'app-webtech-core';

export const changeUrlSlug = (slugType, nonSlugType) => {
  const nonSlugAction = helpers.actions.actionCreator(nonSlugType);
  const slugAction = helpers.actions.actionCreator(slugType);

  return ({ query, ...params }) => (dispatch, getState) => {
    const state = getState();
    let newQuery = query;
    if (!query) {
      newQuery = selectors.location.properties(state).query;
    }
    const action =
      params || Object.keys(params).length !== 0
        ? slugAction({ query: newQuery, ...params })
        : nonSlugAction({ query: newQuery });
    dispatch(action);
  };
};
